import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * InvoiceService provides Call Log API services
 */
class InvoiceService {

    search = (accountId, offset= 0, length= 10, order='date,desc', search= '') => {

        let url = `/api/v2/accounts/${accountId}/invoices` +
            `?offset=${offset}&length=${length}&order=${encodeURI(order)}&search=${encodeURI(search)}`;

        //console.log('InvoiceService.search() url', url, order)
        return new Promise((resolve, reject) => {
            // Get the account data, transforming any errors into a standardised error object
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new InvoiceService();

export default instance;